import { OnInit, ChangeDetectorRef, QueryList, ElementRef } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { forkJoin } from 'rxjs';
import { UsersService } from '../../../shared/services/users.service';
import { NotificationsService } from '../../../shared/services/notification.service';
import { LocalisationService } from '../../../shared/services/localisation.service';
import { ProductsService } from '../../../shared/services/products.service';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { LocalisationPipe } from '../../../shared/pipes/localisation.pipe';
import { MinutesToReadableTimePipe } from '../../../shared/pipes/minutesToReadableTime.pipe';
import { Router } from '@angular/router';
import { AppLoadingEventsEmitter } from '../../../shared/events/loading.events';
import { DialCodeSelectorModalComponent } from '../../../shared/components/profile-sections/dial-code-selector-modal/dial-code-selector-modal.component';
import { BsModalService } from 'ngx-bootstrap';
import { BsModalEventsEmitter } from '../../../shared/events/bsModal.events';
import { StorageService } from '../../../shared/services/storage.service';
import { Constants } from '../../../shared/config/constants.config';
var MobileWizardComponent = /** @class */ (function () {
    function MobileWizardComponent(constants, usersService, changeDetectorRef, notificationService, localisationService, productsService, swiperConfig, localisationPipe, minutesToReadableTimePipe, router, appIsLoadingEventsEmitter, bsModalService, bsModalEventsEmitter, storageService) {
        this.constants = constants;
        this.usersService = usersService;
        this.changeDetectorRef = changeDetectorRef;
        this.notificationService = notificationService;
        this.localisationService = localisationService;
        this.productsService = productsService;
        this.swiperConfig = swiperConfig;
        this.localisationPipe = localisationPipe;
        this.minutesToReadableTimePipe = minutesToReadableTimePipe;
        this.router = router;
        this.appIsLoadingEventsEmitter = appIsLoadingEventsEmitter;
        this.bsModalService = bsModalService;
        this.bsModalEventsEmitter = bsModalEventsEmitter;
        this.storageService = storageService;
        this.loading = false;
        this.activeSlideIndex = 0;
        this.email = '';
        this.id = 0;
        this.firstName = new FormControl('', [Validators.required]);
        this.surname = new FormControl('', [Validators.required]);
        this.phone = new FormControl('', [Validators.required]);
        this.age = new FormControl('', [Validators.required, Validators.min(1), Validators.max(Infinity)]);
        this.enabledByAllergy = {};
        this.customSwiperConfig = {
            slidesPerView: 1,
            spaceBetween: 0,
            allowSlideNext: false,
            allowSlidePrev: true
        };
        this.practicingSports = false;
        this.weight = new FormControl('', [Validators.required]);
        this.target_weight = new FormControl('', [Validators.required]);
        this.height = new FormControl('', [Validators.required, Validators.min(1), Validators.max(Infinity)]);
        this.selectedPhoneDialCode = '';
        this.selectedPreferredCategories = [];
        this.globalCategories = [];
        this.dialCodes = require("../../../../../../config/country_dial_codes.json");
        var language = this.localisationService.getLanguage();
        // if (language && language === Languages.Bulgarian) {
        this.selectedPhoneDialCode = '+359';
        // }
    }
    MobileWizardComponent.prototype.ngOnInit = function () {
        var _this_1 = this;
        if (window.innerWidth > 576) {
            this.customSwiperConfig['allowSlidePrev'] = false;
        }
        this.customSwiperConfig = Object.assign({}, this.swiperConfig, this.customSwiperConfig);
        this.appIsLoadingEventsEmitter.broadcastAppIsLoading(true);
        forkJoin(this.usersService.getGlobalProfiles(), this.usersService.getWhenPrepareFood(), this.usersService.getHowLongFoodPrepare(), this.usersService.getFatHold(), this.usersService.getUserGenders(), this.usersService.getUserTrainingActivities(), this.usersService.getUserTrainingDurations(), this.usersService.getUserTrainingTargets(), this.usersService.getUserBodyTypes(), this.usersService.getUserDailyMeals(), this.productsService.getGlobalCategories(), this.usersService.getUserPreferredGlobalCategories()).subscribe(function (_a) {
            var globalProfiles = _a[0], whenPrepareFoods = _a[1], howLongFoodPrepare = _a[2], fatHolds = _a[3], genders = _a[4], trainingActivities = _a[5], trainingDurations = _a[6], trainingTargets = _a[7], bodyTypes = _a[8], dailyMeals = _a[9], globalCategories = _a[10], userPreferredGlobalCategories = _a[11];
            _this_1.globalProfiles = globalProfiles;
            _this_1.whenPrepareFoods = whenPrepareFoods;
            _this_1.howLongFoodPrepareViewModels = howLongFoodPrepare;
            _this_1.fatHolds = fatHolds;
            _this_1.genders = genders;
            _this_1.trainingActivities = trainingActivities;
            _this_1.trainingDurations = trainingDurations;
            _this_1.trainingTargets = trainingTargets;
            _this_1.bodyTypes = bodyTypes;
            _this_1.dailyMeals = dailyMeals;
            _this_1.globalCategories = globalCategories;
            userPreferredGlobalCategories.map(function (globalCategory) {
                _this_1.addCategoryToPreferred(globalCategory.global_category);
            });
            _this_1.trainingTargets.map(function (target, index) {
                _this_1.trainingTargets[index].target = _this_1.localisationService.localise(target.target);
            });
            _this_1.changeDetectorRef.detectChanges();
            _this_1.initMobileLayout();
            if (_this_1.usersService.userProfile) {
                _this_1.initCurrentUserProfile(_this_1.usersService.userProfile);
            }
            var activeSlideIndex = _this_1.getInitialActiveSlideIndex();
            if (activeSlideIndex === 13) {
                _this_1.sendVerificationMail();
            }
            else if (activeSlideIndex === 0) {
                _this_1.storageService.removeItem('verification_email_sent_' + _this_1.id);
            }
            _this_1.slideTo(activeSlideIndex, 0);
        });
    };
    MobileWizardComponent.prototype.initMobileLayout = function () {
        var wizard = document.getElementById('wizard');
        wizard.style.height = (document.documentElement.clientHeight - 130) + 'px';
    };
    MobileWizardComponent.prototype.onGenderSelected = function (gender) {
        this.currentlySelectedGender = this.genders.find(function (g) { return g.gender === gender; });
    };
    MobileWizardComponent.prototype.updateProfile = function () {
        var _this_1 = this;
        if (this.isDisabled() === true) {
            return;
        }
        // this.appIsLoadingEventsEmitter.broadcastAppIsLoading(true);
        this.nextBtn.forEach(function (btn) {
            btn.nativeElement.classList.add('loading');
        });
        this.loading = true;
        var capitalize = function (s) {
            if (typeof s !== 'string') {
                return '';
            }
            return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
        };
        var profileSection = {
            first_name: capitalize(this.firstName.value),
            last_name: capitalize(this.surname.value),
            dial_code: this.selectedPhoneDialCode,
            phone: this.phone.value,
            age: this.age.value,
            activity: this.currentlySelectedActivity
                ? {
                    id: this.currentlySelectedActivity.id
                }
                : null,
            global_profile: this.currentlyGlobalProfile
                ? {
                    id: this.currentlyGlobalProfile.id
                }
                : null,
            gender: this.currentlySelectedGender
                ? {
                    id: this.currentlySelectedGender.id
                }
                : null,
            allergies: []
        };
        var trainingSection = {
            practice_sports: this.practicingSports ? 'Y' : 'N'
        };
        var bodyType = null;
        if (this.currentlyFatHold && this.currentlyFatHold.body_type) {
            bodyType = { id: this.currentlyFatHold.body_type.id };
        }
        var bodySection = {
            weight: this.weight.value,
            how_long_prepare_food: this.currentlyHowLongFoodPrepare ? this.currentlyHowLongFoodPrepare.id.toString() : null,
            when_prepare_food: this.currentlyWhenPrepareFood ? this.currentlyWhenPrepareFood.id.toString() : null,
            target_weight: this.target_weight.value,
            body_type: bodyType,
            fat_hold: this.currentlyFatHold
                ? {
                    id: this.currentlyFatHold.id
                }
                : null,
            height: this.height.value,
            daily_meals: this.currentlySelectedDailyMeal
                ? {
                    id: this.currentlySelectedDailyMeal.id
                }
                : null,
            diet: null,
            training_target: this.currentlySelectedTrainingTarget ? { id: this.currentlySelectedTrainingTarget.id } : null,
        };
        this.usersService.updateUserProfile(Object.assign({}, profileSection, trainingSection, bodySection)).subscribe(function () {
            _this_1.changeDetectorRef.detectChanges();
            if (_this_1.getInitialActiveSlideIndex() === 9) {
                _this_1.usersService.getUserDailyMeals().subscribe(function (dailyMeals) {
                    _this_1.dailyMeals = dailyMeals;
                    _this_1.changeDetectorRef.detectChanges();
                });
            }
            _this_1.btnNext();
        });
    };
    MobileWizardComponent.prototype.initCurrentUserProfile = function (userProfile, stopLoadingAnimation) {
        if (stopLoadingAnimation === void 0) { stopLoadingAnimation = true; }
        // personal info section
        this.email = userProfile.email;
        this.id = userProfile.id;
        this.firstName.setValue(userProfile.first_name);
        this.surname.setValue(userProfile.last_name);
        this.phone.setValue((userProfile.phone === null ? '' : userProfile.phone));
        this.age.setValue(userProfile.age);
        if (userProfile.dial_code !== null && userProfile.dial_code.length > 0) {
            this.selectedPhoneDialCode = userProfile.dial_code;
        }
        if (this.activities) {
            this.currentlySelectedActivity = userProfile.activity ? this.activities.find(function (a) { return a.id === userProfile.activity.id; }) : undefined;
        }
        // @ts-ignore
        this.currentlyGlobalProfile = userProfile.global_profile ? this.globalProfiles.find(function (a) { return parseInt(a.id) === parseInt(userProfile.global_profile.id); }) : undefined;
        // @ts-ignore
        this.currentlyHowLongFoodPrepare = userProfile.how_long_prepare_food ? this.howLongFoodPrepareViewModels.find(function (a) { return a.id === userProfile.how_long_prepare_food; }) : undefined;
        // @ts-ignore
        this.currentlyWhenPrepareFood = userProfile.when_prepare_food ? this.whenPrepareFoods.find(function (a) { return a.id === userProfile.when_prepare_food; }) : undefined;
        this.currentlySelectedGender = userProfile.gender ? this.genders.find(function (g) { return g.id === userProfile.gender.id; }) : undefined;
        // end of personal info section
        // body info section
        // tslint:disable-next-line:radix
        this.weight.setValue((userProfile.weight === '0.00' ? 0 : Math.round(parseInt(userProfile.weight))));
        if (userProfile.target_weight === null) {
            this.target_weight.setValue(0);
        }
        else {
            // tslint:disable-next-line:radix
            this.target_weight.setValue((userProfile.target_weight === '0.00' ? 0 : Math.round(parseInt(userProfile.target_weight))));
        }
        this.height.setValue((Math.floor(userProfile.height) === 0 ? 0 : Math.round(userProfile.height)));
        this.currentlyFatHold = userProfile.fat_hold ? this.fatHolds.find(function (bt) { return bt.id === userProfile.fat_hold.id; }) : undefined;
        this.currentlySelectedBodyType = userProfile.body_type ? this.bodyTypes.find(function (bt) { return bt.id === userProfile.body_type.id; }) : undefined;
        this.currentlySelectedDailyMeal = userProfile.daily_meals ? this.dailyMeals.find(function (dm) { return dm.id === userProfile.daily_meals.id; }) : undefined;
        this.currentlySelectedTrainingTarget = userProfile.training_target ? this.trainingTargets.find(function (t) { return t.id === userProfile.training_target.id; }) : undefined;
        // end of body info section
        if (stopLoadingAnimation) {
            this.appIsLoadingEventsEmitter.broadcastAppIsLoading(false);
        }
        this.changeDetectorRef.markForCheck();
    };
    MobileWizardComponent.prototype.nextSlide = function () {
        // hide mobile keyboard
        var inputs = document.querySelectorAll('input[type="text"], input[type="number"]');
        for (var i = 0; i < inputs.length; i++) {
            // @ts-ignore
            inputs[i].blur();
        }
        var wizardSwiper = document.querySelector('.wizard-swiper .swiper-container')['swiper'];
        var currentStep = document.querySelector('.swiper-slide-active');
        currentStep.classList.add('animated');
        currentStep.classList.add('fadeOut');
        // next slide transition
        setTimeout(function () {
            wizardSwiper.allowSlideNext = true;
            var nextStep = document.querySelector('.swiper-slide-next');
            nextStep.classList.add('animated');
            nextStep.classList.add('fadeIn');
            wizardSwiper.slideNext(1000);
            setTimeout(function () {
                var allSteps = document.querySelectorAll('.step');
                allSteps.forEach(function (step) {
                    step.classList.remove('animated');
                    step.classList.remove('fadeOut');
                    nextStep.classList.remove('animated');
                    nextStep.classList.remove('fadeIn');
                });
            }, 1000);
            wizardSwiper.allowSlideNext = false;
        }, 150);
    };
    MobileWizardComponent.prototype.prevSlide = function () {
        // hide mobile keyboard
        var inputs = document.querySelectorAll('input[type="text"], input[type="number"]');
        for (var i = 0; i < inputs.length; i++) {
            // @ts-ignore
            inputs[i].blur();
        }
        var wizardSwiper = document.querySelector('.wizard-swiper .swiper-container')['swiper'];
        var currentStep = document.querySelector('.swiper-slide-active');
        currentStep.classList.add('animated');
        currentStep.classList.add('fadeOut');
        // next slide transition
        setTimeout(function () {
            var defaultValue = wizardSwiper.allowSlidePrev;
            wizardSwiper.allowSlidePrev = true;
            var prevStep = document.querySelector('.swiper-slide-prev');
            prevStep.classList.add('animated');
            prevStep.classList.add('fadeIn');
            wizardSwiper.slidePrev(1000);
            setTimeout(function () {
                var allSteps = document.querySelectorAll('.step');
                allSteps.forEach(function (step) {
                    step.classList.remove('animated');
                    step.classList.remove('fadeOut');
                    prevStep.classList.remove('animated');
                    prevStep.classList.remove('fadeIn');
                });
            }, 1000);
            wizardSwiper.allowSlidePrev = defaultValue;
        }, 150);
    };
    MobileWizardComponent.prototype.slideTo = function (index, speed) {
        var wizardSwiper = document.querySelector('.wizard-swiper .swiper-container')['swiper'];
        wizardSwiper.allowSlideNext = true;
        wizardSwiper.slideTo(index, speed);
        wizardSwiper.allowSlideNext = false;
    };
    MobileWizardComponent.prototype.isSwiperEnd = function () {
        var wizardSwiper = document.querySelector('.wizard-swiper .swiper-container')['swiper'];
        return wizardSwiper.isEnd;
    };
    MobileWizardComponent.prototype.onSelectedBodyType = function (id) {
        this.currentlySelectedBodyType = id;
    };
    MobileWizardComponent.prototype.onDialCodeChange = function (event) {
        this.selectedPhoneDialCode = event.target.value;
        this.changeDetectorRef.markForCheck();
    };
    MobileWizardComponent.prototype.openDialCodeModal = function () {
        this.dialCodeModal = this.bsModalService.show(DialCodeSelectorModalComponent, {
            backdrop: true
        });
        this.dialCodeModal.content.personalOrWizardComponent = this;
        this.bsModalEventsEmitter.broadcastBsModalStateChanged(this.dialCodeModal);
    };
    MobileWizardComponent.prototype.isPrevBtnVisible = function () {
        var wizardSwiper = document.querySelector('.wizard-swiper .swiper-container');
        if (!wizardSwiper) {
            return false;
        }
        var currentSlide = wizardSwiper['swiper']['realIndex'];
        if (currentSlide === 0 || this.customSwiperConfig.allowSlidePrev === true) {
            return false;
        }
        return true;
    };
    MobileWizardComponent.prototype.isDisabled = function () {
        if (this.firstName.value.length <= 0 || this.loading === true) {
            return true;
        }
        var wizardSwiper = document.querySelector('.wizard-swiper .swiper-container')['swiper'];
        var currentSlide = wizardSwiper['realIndex'];
        if (currentSlide === 0 && this.firstName.value.length < 3) {
            return true;
        }
        if (currentSlide === 1 && this.surname.value.length < 3) {
            return true;
        }
        if (currentSlide === 2 && this.age.value <= 0) {
            return true;
        }
        if (currentSlide === 3 && !this.currentlyGlobalProfile) {
            return true;
        }
        if (currentSlide === 4 && !this.currentlySelectedGender) {
            return true;
        }
        if (currentSlide === 5 && this.weight.value <= 10) {
            return true;
        }
        if (currentSlide === 6 && this.target_weight.value <= 10) {
            return true;
        }
        if (currentSlide === 7 && this.height.value <= 10) {
            return true;
        }
        if (currentSlide === 8 && !this.currentlyFatHold) {
            return true;
        }
        if (currentSlide === 9 && !this.currentlySelectedDailyMeal) {
            return true;
        }
        if (currentSlide === 10 && !this.currentlyHowLongFoodPrepare) {
            return true;
        }
        if (currentSlide === 11 && !this.currentlyWhenPrepareFood) {
            return true;
        }
        return false;
    };
    MobileWizardComponent.prototype.getBodyTypeTranslationKey = function (bodyTypeId) {
        if (bodyTypeId === 4) {
            return 'ectomorph_text';
        }
        if (bodyTypeId === 5) {
            return 'mesomorph_text';
        }
        return 'endomorph_text';
    };
    MobileWizardComponent.prototype.getInitialActiveSlideIndex = function () {
        if (this.firstName.value.length <= 0) {
            return 0;
        }
        if (this.surname.value.length <= 0) {
            return 1;
        }
        if (this.age.value <= 0) {
            return 2;
        }
        if (!this.currentlyGlobalProfile) {
            return 3;
        }
        if (!this.currentlySelectedGender) {
            return 4;
        }
        if (this.weight.value <= 10) {
            return 5;
        }
        if (this.target_weight.value <= 10) {
            return 6;
        }
        if (this.height.value <= 10) {
            return 7;
        }
        if (!this.currentlyFatHold) {
            return 8;
        }
        if (!this.currentlySelectedDailyMeal) {
            return 9;
        }
        if (!this.currentlyHowLongFoodPrepare) {
            return 10;
        }
        if (!this.currentlyWhenPrepareFood) {
            return 11;
        }
        if (this.selectedPreferredCategories.length < 2) {
            return 12;
        }
        return 13;
    };
    MobileWizardComponent.prototype.openEmailProviderWebsite = function () {
        var split = this.email.split('@');
        var win = window.open('https://' + split[1], '_blank');
        win.focus();
    };
    MobileWizardComponent.prototype.sendVerificationMail = function () {
        var _this_1 = this;
        console.log('verification email was called ');
        console.log(this.storageService.getItem('verification_email_sent_' + this.id) === null);
        console.log(this.storageService.getItem('verification_email_sent_' + this.id).length);
        var isEmailSent = this.storageService.getItem('verification_email_sent_' + this.id);
        if (isEmailSent === null || isEmailSent.length <= 0) {
            this.usersService.sendVerificationEmail().subscribe(function () {
                console.log('verification send');
                _this_1.storageService.setItem('verification_email_sent_' + _this_1.id, '1');
            });
        }
        // check constantly for email verification
        var iterations = 0;
        var intervral = setInterval(function () {
            iterations += 1;
            _this_1.usersService.getUserProfile().subscribe(function (userProfile) {
                if (userProfile.is_wizard_complete === true && userProfile.is_email_verified === true) {
                    clearInterval(intervral);
                    _this_1.router.navigate(['pricing']);
                }
            }, function () {
                clearInterval(intervral);
                window.location.reload();
            });
            if (iterations > 1000) {
                clearInterval(intervral);
            }
        }, 1500);
    };
    MobileWizardComponent.prototype.addCategoryToPreferred = function (category) {
        if (this.isCategoryPreferred(category)) {
            this.selectedPreferredCategories.splice(this.selectedPreferredCategories.indexOf(category.id), 1);
        }
        else {
            this.selectedPreferredCategories.push(category.id);
        }
        this.changeDetectorRef.markForCheck();
    };
    MobileWizardComponent.prototype.isCategoryPreferred = function (category) {
        for (var _i = 0, _a = this.selectedPreferredCategories; _i < _a.length; _i++) {
            var categoryId = _a[_i];
            // @ts-ignore
            // tslint:disable-next-line:radix
            if (categoryId === parseInt(category.id)) {
                return true;
            }
        }
        return false;
    };
    MobileWizardComponent.prototype.updateUserPreferredCategories = function () {
        var _this_1 = this;
        if (this.selectedPreferredCategories.length < 2) {
            return false;
        }
        this.appIsLoadingEventsEmitter.broadcastAppIsLoading(true);
        this.usersService.setUserPreferredCategories(this.selectedPreferredCategories).subscribe(function () {
            _this_1.appIsLoadingEventsEmitter.broadcastAppIsLoading(false);
            _this_1.btnNext();
        }, function () {
            _this_1.appIsLoadingEventsEmitter.broadcastAppIsLoading(false);
        });
    };
    MobileWizardComponent.prototype.btnNext = function () {
        var leftRequiredIndex = this.getInitialActiveSlideIndex();
        var _this = this;
        setTimeout(function () {
            if (_this.isSwiperEnd() && leftRequiredIndex !== 12) {
                _this.slideTo(leftRequiredIndex, 1000);
            }
            else {
                _this.nextSlide();
            }
            setTimeout(function () {
                _this.nextBtn.forEach(function (btn) {
                    btn.nativeElement.classList.remove('loading');
                });
                _this.loading = false;
                _this.changeDetectorRef.markForCheck();
            }, 1000);
            setTimeout(function () {
                var swiper = document.querySelector('.wizard-swiper .swiper-container')['swiper'];
                if (swiper.activeIndex === 13) {
                    _this.sendVerificationMail();
                }
            }, 1005);
        }, 500);
    };
    MobileWizardComponent.prototype.sendAgain = function () {
        var _this_1 = this;
        this.appIsLoadingEventsEmitter.broadcastAppIsLoading(true);
        this.usersService.sendVerificationEmail().subscribe(function () {
            _this_1.appIsLoadingEventsEmitter.broadcastAppIsLoading(false);
            _this_1.notificationService.success('Мейла е изпратен успешно!');
            console.log('verification send');
        });
    };
    return MobileWizardComponent;
}());
export { MobileWizardComponent };
